import React from "react";
import CourseFeeList from "./List/CourseFeeList";


const CourseFee = () => {
    return <CourseFeeList type="list" title="Course Fees"/>;
};

export default CourseFee;
